import { labelMap } from '@/api';
import { get, post } from '@/common/request';

export interface LabelClassify {
  id?: number;
  name?:	string;
  parentId?:	null;
  remark?: string;
  sortNum?:number;
  tntResourceLabelVOList?: SearchParams[];
}

export interface SearchParams {
tenantLabelClassificationId?:	number;
name?: string
visibleMode?:	0 | 1
needReview?: 0 | 1
sortNum?: number
}

export interface LabelItem extends SearchParams {
  meta?: any;
  id?: number;
  tenantLabelClassificationName?: string;
};

interface LabelListResponce {
  totalNum?: number;
  pageNum?:	number;
  pageSize?: number;
  objectList?: LabelItem[];
  meta?: any;
}

class Label {
  getClassifys(): Promise<LabelClassify[]> {
    return get(labelMap.get('classifyList'), {}, { needHint: true });
  }

  getLabelTree(): Promise<LabelClassify[]> {
    return post(labelMap.get('tree'), {}, { proxyApi: '/resserv', needHint: true });
  }

  deleteClassify(id: number) {
    return post(labelMap.get('deleteClassify'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  sortClassify(sorts: {id: number, index: number}[]): Promise<boolean> {
    return post(labelMap.get('sort'), { items: sorts }, { proxyApi: '/resserv', needHint: true });
  }

  getList(searchParams: any): Promise<LabelListResponce> {
    return post(labelMap.get('list'), { ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  editLable(values: LabelItem): Promise<boolean> {
    return post(labelMap.get('edit'), values, { proxyApi: '/resserv', needHint: true });
  }

  deleteLable(id: number): Promise<boolean> {
    return post(labelMap.get('delete'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  preSubmitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceId: any) {
    return post(labelMap.get('preSubmit'), { resourceType, labelClassificationList, tntResourceId }, { proxyApi: '/resserv', needHint: true });
  }

  submitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceId: any) {
    return post(labelMap.get('submit'), { resourceType, labelClassificationList, tntResourceId }, { proxyApi: '/resserv', needHint: true });
  }

  batchSubmitLabel(resourceType: 0 | 1, labelClassificationList: any[], tntResourceIdList: number[]) {
    return post(labelMap.get('batchSubmit'), { resourceType, labelClassificationList, tntResourceIdList }, { proxyApi: '/resserv', needHint: true });
  }

  detail(resourceType: 0| 1, tntResourceId): Promise<LabelClassify[]> {
    return post(labelMap.get('detail'), { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
  }

  getRelationList(resourceType: 0| 1, tntResourceId?: number): Promise<LabelClassify[]> {
    return post(labelMap.get('relationList'), { resourceType, tntResourceId }, { proxyApi: '/resserv', needHint: true });
  }

}


export default new Label();
